module.exports = __WEBPACK_EXTERNAL_MODULE_6__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"dicom-parser","commonjs2":"dicom-parser","amd":"dicom-parser","root":"dicomParser"}
// module id = 6
// module chunks = 0